export default {
  'profileaccounts.accountsmanagement': 'Bank Accounts Management',
  'profileaccounts.bankname': 'Bank Name',
  'profileaccounts.branchname': 'Branch Name',
  'profileaccounts.accountno': 'Account Number',
  'profileaccounts.cardno': 'Card Number',
  'profileaccounts.shebano': 'Sheba Number',
  'profileaccounts.ismain': 'Is Default Account',
  'profileaccounts.register': 'Add',
  'profileaccounts.delete': 'Delete',
  'profileaccounts.deleteaccount': 'Delete Bank Account',
  'proprofileaccountsfile.cancel': 'Cancel',
  'profileaccounts.deleteconfirmation': 'Are you sure to delete Bank Account ?',
  'profileaccounts.accountadd': 'Bank Account Added Successfully!',
  'profileaccounts.tryagain': 'Please Try Again',
  'profileaccounts.enterinfo': 'Please Enter Your Account Info',
  'profileaccounts.addaccount': 'Add Bank Account',
  'profileaccounts.cardno-account': 'Card / Account Number',
  'profileaccounts.accountsmanage': 'Bank Accounts Management',
  'profileaccounts.Textaccountsmanage':
    'You can register the desired account through the following form.',
};
